/* eslint-disable no-unused-vars */
import classNames from 'classnames';
import moment from 'moment';
import { checkIfStringIsZeroOrEmpty } from '../../../utils/StringUtils/StringUtils';
import {
  convertStringToInt,
  convertStringToNumber,
} from '../../../utils/ConvertStringToNumber/convertStringToNumber';

const ParcelRateCell = ({
  name,
  field,
  type = 'text',
  data,
  setData,
  maxLength = 100,
  customClassName = '',
  index,
  recentlyUpdatedData,
  originalData,
  nullable = false,
  isNew = false,
}) => {
  const handleChange = (currentValue) => {
    let value;

    if (type === 'number') {
      value = convertStringToNumber(currentValue, nullable);
    } else if (type === 'number-int') {
      value = convertStringToInt(currentValue, true);
    } else if (type === 'date') {
      value = currentValue ? `${currentValue}T00:00:00` : null;
    } else {
      value = currentValue;
    }

    if (value === '' || (type === 'number' && isNaN(value))) {
      value = null;
    }
    setData((prevData) =>
      prevData.map((item, i) =>
        i === index ? { ...item, [field]: value } : item,
      ),
    );
  };

  // Format the value for display in the input
  const getInputValue = () => {
    const rawValue = data[index]?.[field];
    if (type === 'date' && rawValue) {
      // Parse with moment and format to YYYY-MM-DD
      return moment(rawValue).isValid()
        ? moment(rawValue).format('YYYY-MM-DD')
        : '';
    }
    return checkIfStringIsZeroOrEmpty(rawValue);
  };

  return (
    <div className="text-xs inline-block">
      <div className="relative">
        <input
          maxLength={maxLength}
          value={getInputValue()}
          type={type !== 'number' ? type : 'text'}
          onChange={(e) => handleChange(e.target.value)}
          className={classNames(
            'outline-none border-b border-blue-800 focus:border-blue-400 px-2',
            customClassName,
            !!originalData &&
              data[index]?.[field] !== originalData?.[index]?.[field] &&
              'bg-green-200',
            (data[index]?.[field] !== recentlyUpdatedData?.[index]?.[field] ||
              isNew) &&
              '!bg-red-200',
          )}
          placeholder={`${name || field}...`}
        />
      </div>
    </div>
  );
};

export default ParcelRateCell;
